import { put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  GET_PALLETES_SAGA,
  GET_MATERIALS_SAGA,
  MATERIALS_FETCHED,
  PALLETES_FETCHED,
  ADD_PALLETE_SAGA,
  DELETE_PALLETE_SAGA,
  EDIT_PALLETE_SAGA,
  PALLETE_ADDED,
  PALLETE_DELETED,
  PALLETE_EDITED,
  END_LOADING,
} from "../actionTypes";

import { apiCaller } from "../../custom-hooks/useApi";
import { pallete_apiCalls } from "../../services/agent";

export function* getPalletesSaga(action) {
  const { data, status } = yield apiCaller({
    api: pallete_apiCalls.apiCall_getPalletes,
    apiArguments: action.payload,
    toastMessage: true,
    onErrorMessage: "دریافت کالیته ها با خطا مواجه شد.",
  });

  if (status === 200) {
    yield put({ type: PALLETES_FETCHED, payload: data.data.data });
  } else {
    yield put({ type: END_LOADING });
  }
}
export function* getMaterialsSaga(action) {
  const { data, status } = yield apiCaller({
    api: pallete_apiCalls.apiCall_getPalleteMaterials,
    toastMessage: true,
    onErrorMessage: "دریافت متریال ها با خطا مواجه شد.",
  });

  if (status === 200) {
    yield put({ type: MATERIALS_FETCHED, payload: data.data.data });
  } else {
    yield put({ type: END_LOADING });
  }
}

export function* addPalleteSaga(action) {
  const { payload } = action;
  const { status } = yield apiCaller({
    api: pallete_apiCalls.apiCall_createPallete,
    apiArguments: payload.addPalletData,
    toastMessage: true,
    onErrorMessage: "افزودن کالیته با خطا مواجه شد.",
    onSuccessMessage: "افزودن کالیته با موفقیت انجام شد .",
  });


  console.log(payload.fetchPallets)

  if (status === 200) {
    yield put({ type: GET_PALLETES_SAGA, payload:payload.fetchPallets });
  } else {
    yield put({ type: END_LOADING });
  }
}

export function* deletePalleteSaga(action) {
  const { payload } = action;
  const { status } = yield apiCaller({
    api: pallete_apiCalls.apiCall_deletePallete,
    apiArguments: payload,
    toastMessage: true,
    onErrorMessage: "حذف کالیته با خطا مواجه شد.",
    onSuccessMessage: "حذف کالیته با موفقیت انجام شد .",
  });

  if (status === 200) {
    yield put({ type: PALLETE_DELETED, payload: payload });
  } else {
    yield put({ type: END_LOADING });
  }
}

export function* editPalleteSaga(action) {
  const { payload } = action;

  const { status } = yield apiCaller({
    api: pallete_apiCalls.apiCall_editPallete,
    apiArguments: payload,
    toastMessage: true,
    onErrorMessage: "ویرایش کالیته با خطا مواجه شد.",
    onSuccessMessage: "ویرایش کالیته با موفقیت انجام شد .",
  });

  if (status === 200) {
    yield put({ type: PALLETE_EDITED, payload: payload });
  } else {
    yield put({ type: END_LOADING });
  }
}

export function* watchAddPalleteSaga() {
  yield takeLatest(ADD_PALLETE_SAGA, addPalleteSaga);
}
export function* watchDeletePalleteSaga() {
  yield takeLatest(DELETE_PALLETE_SAGA, deletePalleteSaga);
}
export function* watchEditPalleteSaga() {
  yield takeLatest(EDIT_PALLETE_SAGA, editPalleteSaga);
}

export function* watchGetPalletesSaga() {
  yield takeLatest(GET_PALLETES_SAGA, getPalletesSaga);
}
export function* watchGetMaterialsSaga() {
  yield takeLatest(GET_MATERIALS_SAGA, getMaterialsSaga);
}
